import { CompetitionsBannerViewModel } from "MVVM/Views/Homepage/CompetitionsBanner/ViewModel";
import { getCompetitionPhase } from "MVVM/Views/Competitions/utils";

/**
 * Drives the Compete panel's CTA. Reuses the homepage's selection and its Apollo
 * cache entry; the homepage only features sponsored comps, so this falls back to
 * whatever is running. Hooks cannot be conditional, hence the skip.
 */
export const useFeaturedCompetition = (enabled: boolean) => {
  const { featured, others } = CompetitionsBannerViewModel({ skip: !enabled });

  if (!enabled) return null;
  return (
    featured ?? others.find((c) => getCompetitionPhase(c) !== "ended") ?? null
  );
};
